<template>
  <footer>
    <p>
      Feito com <i class="fa-solid fa-heart"></i> por <a
        href="https://github.com/stsmuniz"
        target="_blank"
    >
      @stsmuniz
    </a>
    </p>
  </footer>
</template>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
footer {
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  a, fa-solid {
    color: $emphasis;
  }
}
</style>
